import { SxProps, Theme } from '@mui/material';

export const getSpinnerContainerSx = (): SxProps<Theme> => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const getCircularProgressSx = (color: string): SxProps<Theme> => ({
  color,
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    opacity: 0.6,
  },
});
